export enum CallListDistributionFilterTypeEnum {
    PopulationDescription = 'Population',
    Population = 1,
    ZipCodeGroupDescription = 'Zip Code Group',
    ZipCodeGroup = 2,
    BothDescription = 'Both',
    Both = 3,
}
